import {Component, OnDestroy, OnInit} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {gql} from '@apollo/client';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {environment} from 'src/environments/environment';
import {UserRole} from '../shared/graphql/globalTypes';
import {HomeComponent_getMeAndCoachingProgramme} from './__generated__/HomeComponent_getMeAndCoachingProgramme';

const GET_ME_AND_COACHING_PROGRAMME = gql`
  query HomeComponent_getMeAndCoachingProgramme {
    me {
      id
      fullname
      language
      role
      tenant {
        id
      }
    }
    coachingProgramme {
      id
      textFileUrl
    }
  }
`;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  myFullName = '';
  apiUrl = environment.host;
  coachingProgrammeUrl: string | null = null;
  userRole: UserRole | null = null;
  UserRole = UserRole;
  tenantId: string | null = null;

  constructor(
    private apollo: Apollo,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.apollo
        .watchQuery<HomeComponent_getMeAndCoachingProgramme>({
          query: GET_ME_AND_COACHING_PROGRAMME,
        })
        .valueChanges.subscribe(result => {
          this.myFullName = result.data.me.fullname;
          this.userRole = result.data.me.role;
          this.tenantId = result.data.me.tenant.id;
          if (result.data.me.language) {
            this.translateService.use(result.data.me.language.toLowerCase());
            localStorage.setItem('language', result.data.me.language.toLowerCase());
          }
          this.coachingProgrammeUrl = result.data.coachingProgramme?.textFileUrl ?? null;
        }),
    );
  }

  onLogOut() {
    location.href = `${this.apiUrl}accounts/logout`;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
